<style scoped lang="scss">
  @import "../user";
  @import "./ipone";
  .status-box{
    display: flex;
    align-items: center;
  }
  .mask-tips{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0,0,0,0.5);
  }
  .outer-box{
    z-index: -1;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    left: -15px;
    right: -15px;
    bottom: -6px;
    top: -6px;
  }
  .result-btn{
    position: relative;
  }
</style>
<style>
@import url('../data.css');
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">项目订单</h3>
      <div class="search-form search-form1">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="关联用户：" v-if="isHeadMan">
            <el-select v-model="searchForm.customerId" filterable clearable>
              <el-option
                      v-for="item in courseInfo.members"
                      :key="item.id"
                      :label="item.realName"
                      :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="时间：" class="date">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="bindSearch" class="search-button">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="status-box">
          <div style="flex:1">
             订单状态：
              <el-radio-group v-model="status" @change="getOrders">
                <el-radio label="">全部</el-radio>
                <el-radio label="ING">进行中</el-radio>
                <el-radio label="OK">已完成</el-radio>
              </el-radio-group>
          </div>
          
          <div :style="{zIndex: popoverVisible ? 1001 : 1}" class="result-btn" ref="result" >
            <el-button v-popover:popover type="primary" @click="$throttle(bindDownLoad())" class="sanger_button">
              结果下载
              <el-tooltip content="可能存在无结果文档的订单，如出现可与销售人员进行联系" placement="top">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </el-button>
            
            <el-popover
              ref="popover"
              width="380"
              placement="top-end"
              trigger="manual"
              :offset="-15"
              :value="popoverVisible">
              <div class="status-box">
                <div style="flex:1">
                  <h4>新增功能</h4>
                  <p>
                    订单中结果文档可以通过该功能下载了，部分订单中可能存在无结果文件的情况，如果出现请与销售人员进行联系
                  </p>
                </div>
                <el-button size="small"  type="primary" plain @click="hidePopover" class="ml10">知道了</el-button>
              </div>
            </el-popover>
            <div v-if="popoverVisible" class="outer-box"></div>
          </div>
          
        </div>
       
      </div>
      <el-table
        v-loading="loading"
        class="mt20"
        border
        :data="orderLists"
        @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          label="订单编号">
          <template slot-scope="scope">
            <router-link :to="`/user/project_details?id=${scope.row.value.id}`">{{scope.row.value.no}}</router-link>
          </template>
        </el-table-column>
        <el-table-column
          label="下单时间">
          <template slot-scope="scope">
            {{scope.row.value.createTime | rTime}}
          </template>
        </el-table-column>
        <el-table-column
          prop="value.name"
          label="项目名称">
        </el-table-column>
        <el-table-column
          prop="value.type"
          label="项目类型">
        </el-table-column>
        <el-table-column
          v-if="isHeadMan"
          prop="customerName"
          label="关联用户">
        </el-table-column>
        <el-table-column
          label="订单金额（元）">
          <template slot-scope="scope">{{scope.row.value.amount | amount}}</template>
        </el-table-column>
        <el-table-column
          prop="value.statusName"
          label="订单状态">
        </el-table-column>
      </el-table>
      <div class="page tr">
        <el-pagination
          :page-size="10"
          :pager-count="10"
          layout="prev, pager, next"
          :total="total"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
    <div v-if="popoverVisible" class="mask-tips"></div>
  </div>
</template>

<script>
import { project,projectOrdersDownload } from '@/services/api.index';
import { mapState,mapActions } from 'vuex';
import { showLoading, hideLoading } from './loading'
export default {
  data() {
    return {
      loading: false,
      userType: 1, // 1组长 2组员
      searchForm: {
        customerId: '',
        orderNo: '',
        date: null
      },
      selectedList:[], //选择的项目订单
      status: '',
      orderLists: [],
      total: 0,
      page: 0,
      pageSize: 10,
      isHeadMan: this.baseMethods.isHeadMan(),
      courseInfo: this.baseMethods.getLocalObj('courseInfo'),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;  //如果没有后面的-8.64e6就是不可以选择今天的
        }
      }
    }
  },
  computed: {
    ...mapState( {
      popoverVisible: state => state.firstVisit.projectDownload
    })
  },
  created() {
    this.getOrders()
    this.$refs.reference.click()
  },
  mounted(){    
  console.log(process.env.BASE_API)
    this.$nextTick(()=>{
      this.getRecords({
        key: "projectDownload",
        modules: "WEB_PROJECT_ORDER_1",
        mutations: "SET_PROJECT_DOWNLOAD",
      })
      if(this.popoverVisible){
        document.body.style.overflowY = "hidden"
      }
      console.log("mounted",this.popoverVisible)
    })
    
  },
  methods: {
    ...mapActions(['getRecords','setRecords']),
    handleSelectionChange(val){
      this.selectedList = val
    },
    // 下载
    bindDownLoad() {
      if(this.popoverVisible) return 
      const { selectedList } = this;
      if (selectedList.length === 0) {
        return this.$message.warning("请选择要下载结果的订单");
      }
      if(!selectedList.some((v) => v.hasFile)){
        return this.$message.warning("当前订单无可下载的结果文档，如急需可与销售人员进行联系");
      }
      showLoading({text: "处理中，请稍后"});
      setTimeout(() => {
        let ids = selectedList.map((v) => v.value.id);
        projectOrdersDownload(ids).then((res) => {
          hideLoading();
          this.baseMethods.downloadFile(
            res.data,
            `项目结果文档${this.baseMethods.dateToString()}`,
            "zip"
          );
          this.$message.success("操作成功")
        }).catch(()=>{
          hideLoading();
        })
      },2000);
    },
    hidePopover() {
      document.body.style.overflowY = "auto"
      this.setRecords({
        value: false,
        guideModule: "WEB_PROJECT_ORDER_1",
        mutations: "SET_PROJECT_DOWNLOAD",
      })
    },
    // 订单列表
    getOrders () {
      this.loading = true
      const { page, pageSize, status } = this
      let { orderNo, date, customerId } = this.searchForm
      date = date || ['', '']
      const searchIds = this.baseMethods.getSearchId(customerId)
      project(page, pageSize, orderNo, ...date, status, ...searchIds).then(res => {
        res.data.list.map(item => {
          let statusName = ''
          switch (item.userWebOrderStatus) {
            case 'ING':
              statusName = '进行中'
              break
            case 'OK':
              statusName = '已完成'
              break
          }
          item.value.statusName = statusName
        })
        this.orderLists = res.data.list
        this.total = res.data.totalCount
      }).finally(() => {
        this.loading = false
      })
    },
    bindSearch () {
      this.page = 0
      this.getOrders()
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getOrders()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/project.vue